import { Button, Container } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import Elements from '../../../Elements';

export default function WalletIntro({ classes }) {
  const navigate = useNavigate();
  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <Elements.Navigator title="" noBorder />
        <div className="center">
          <img src={Images.Logo} alt="box pack" className="mt-4" height={65} />
          <h4 className="mt-5">Welcome to Oenowallet</h4>
          <div className="s-14 mt-1 mute">Pay easy, secure, and guarantee</div>
        </div>

        <Container className="mt-6">
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img src={Images.OenoGuarantee} alt="safety" height="42" />
            <div>
              <div className="weight-700">Oeno verified guarantee</div>
              <div className="mt-1 height-14 s-12 mute">We verified all wines and guarantee the originality</div>
            </div>
          </div>
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img src={Images.OenoStorage} alt="safety" height="42" />
            <div>
              <div className="weight-700">Oeno storage</div>
              <div className="mt-1 height-14 s-12 mute">Secure storage for your valuable and collectible wine</div>
            </div>
          </div>
          <div className="flex gap-12 align-items-center mt-3 benefit-card">
            <img src={Images.OenoMarket} alt="safety" height="42" />
            <div>
              <div className="weight-700">Oeno market</div>
              <div className="mt-1 height-14 s-12 mute">Best marketplace to find perfect wine for your perfect occasion</div>
            </div>
          </div>
        </Container>

        <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth onClick={() => navigate(`${ROUTES.wallet()}/terms`)}>Setup Oenowallet</Button>
          </Container>
        </div>
      </div>
    </Elements.PageBase>
  );
}
